import { observer } from 'mobx-react-lite'

import { IntervalInputs } from 'components'
import { useValueContext } from 'contexts'

import BellIcon from '../../img/bell.svg?react'

interface Props {
  onChange: (field: string) => (value: string | number) => void
  enableTabIndex?: boolean
}

export const Step2 = observer(({ enableTabIndex, onChange }: Props) => {
  const { settings } = useValueContext()
  const { feedNotification, sleepNotification } = settings

  return (
    <>
      <div className="reminder-subheader">
        <BellIcon className="reminder-icon" />
        Вы будете получать <br />
        напоминания о
      </div>
      <div className="step2-input-wrapper">
        <div className="title">Кормлении малыша:</div>
        <IntervalInputs
          onChange={onChange}
          enableTabIndex={enableTabIndex}
          hoursValue={feedNotification.hours}
          minutesValue={feedNotification.minutes}
          hoursFieldName="feedNotification.hours"
          minutesFieldName="feedNotification.minutes"
        />
      </div>
      <div className="step2-input-wrapper">
        <div className="title">Укладывании спать:</div>
        <IntervalInputs
          onChange={onChange}
          enableTabIndex={enableTabIndex}
          hoursValue={sleepNotification.hours}
          minutesValue={sleepNotification.minutes}
          hoursFieldName="sleepNotification.hours"
          minutesFieldName="sleepNotification.minutes"
        />
      </div>
      <div className="notice">
        Вы можете изменить эти интервалы позднее <br />в настройках приложения
      </div>
    </>
  )
})
